/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef, useState } from "react"
import {
  Checkbox,
  FormControlLabel,
  Grid,
  Radio,
  TextField,
} from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { ItemContext } from "../ComponentLoader"
import ReactPlayer from "react-player"
import AssetDatabase from "../../../utils/assetDatabase"
import TableCell from "@material-ui/core/TableCell"
import TableRow from "@material-ui/core/TableRow"
import Typography from "@material-ui/core/Typography"
import Card from "@material-ui/core/Card"
import CardContent from "@material-ui/core/CardContent"
import CardMedia from "@material-ui/core/CardMedia"
import AudioImageItemSettings from "./AudioImageComponent/AudioImageItemSettings"
import PlayerController from "./VideoComponent/PlayerController"
import AudioImage from "./AudioImageComponent/AudioImage"
import ComponentLink from "./General/ComponentLink"
import DefaultSettings from "../../../defaultSettings/settings"
import SelectAsset from "../settings/SelectAsset"
import AutoAssignButton from "../AutoAssignButton"
import EditIcon from "@material-ui/icons/Edit"
import IconButton from "@material-ui/core/IconButton"
import { useLiveQuery } from "dexie-react-hooks"
import DatabaseIndexedDb from "../../../IndexedDB/DatabaseIndexedDb"

import { dataURLtoFile } from "../../../utils/dataURLtoFile"
import FontSettings from "../../../data/FontSettings"
import Database from "../../../utils/database"
import CustomColorPicker from "../../customColorPicker"

export const AudioImageSettings = {
  type: "AudioImage",
  title: "Audio & Images (Slideshow)",
  support: ["iwa", "tourbuilder", "kiosk"],
  img: require("../../../images/image_component.png"),
  color: "#00688F",
}
export const AudioImageAdvancedSettings = {
  images: [],
  transcript: false,
  transcriptText: "",
  assets: {
    main: {
      name: "",
    },
    audio: {
      name: "",
    },
  },
  themeSettings: "dark",
  fontSettings: "white",
}

export const AudioImageCheckForWarnings = (component) => {
  let warnings = []
  if (!component.data.advancedSettings.assets.main.name) {
    warnings.push({
      type: "warning",
      title: `${component.data.title} does not have a background image`,
    })
  }

  for (
    let index = 0;
    index < component.data.advancedSettings.images.length;
    index++
  ) {
    const image = component.data.advancedSettings.images[index]
    if (!image.name) {
      warnings.push({
        type: "warning",
        title: `${component.data.title} slideshow item ${
          index + 1
        } does not have a image assigned to it`,
      })
    }
  }

  console.log("list warnings: ", warnings)

  /// review all assets, e.g. size, bitrate and resolution
  return warnings
}

export const AudioImageAssets = (component) => {
  let assets = []

  if (component.data.advancedSettings.assets.audio.name != "") {
    assets.push(component.data.advancedSettings.assets.audio.name)
  }
  for (
    let index = 0;
    index < component.data.advancedSettings.images.length;
    index++
  ) {
    const image = component.data.advancedSettings.images[index]
    if (image.name !== "") {
      assets.push(image.name)
    }
  }
  return assets
}

export const AudioImagePlayerLayers = (props) => {
  const useStyles = makeStyles({
    root: {
      width: 250,
    },
    input: {
      width: 42,
    },
  })
  const classes = useStyles()
  const itemContext = useContext(ItemContext)
  const {
    item,
    previewMode,
    siblings,
    updateItem,
    TourPlayer,
    buttonPressed,
    portrait,
    device,
  } = itemContext
  const { advancedSettings } = item.data
  const [rcp, setRcp] = React.useState(null)
  let topRows = null
  let bottomRows = null
  let middleRows = null
  let blockLinkTo = null

  const myRef = useRef(null)
  const [myComponenetWidth, setMyComponentWidth] = useState(0)
  const [myComponenetHeight, setMyComponentHeight] = useState(0)
  const [onClickForPlayer, setOnClickForPlayer] = useState(false)
  const handleResize = () => {
    const info = myRef.current.getBoundingClientRect()
    setMyComponentWidth(info.width)
    setMyComponentHeight((info.width / 9) * 16)
    console.log("resize 360: ", info.width, info.height)
  }
  useEffect(() => {
    if (myRef.current) {
      console.log("360 has rendered")
      refCallback(myRef.current)
      window.addEventListener("resize", handleResize)
    }

    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [myRef])

  const [state, setState] = React.useState({
    seeking: false,
    playing: previewMode,
    duration: 0,
    played: 0,
    playedSeconds: 0,
  })
  const [duration, setDuration] = React.useState(0)
  const myPlayerRef = useRef(null)
  const [player, setPlayer] = React.useState(null)
  const [openSettings, setOpenSettings] = React.useState(false)

  const [bgAssetFullPath, setbgAssetFullPath] = useState("")
  const { audio } = item.data.advancedSettings.assets

  const indexedDBObj = new DatabaseIndexedDb(item.tourDetails.id)
  const componentAudio = useLiveQuery(
    () =>
      indexedDBObj.db.tours
        .where("name")
        .equals(audio.name || "")
        .toArray(),
    [audio]
  )

  useEffect(() => {
    const test = () => {
      if (componentAudio !== undefined) {
        getTempAudioPath(item.data.advancedSettings.assets.audio.name)
      }
    }
    test()
  }, [item.data.advancedSettings.assets.audio, componentAudio])

  const getTempAudioPath = async (_audioname) => {
    let _path = `${item.clientId}/${item.projectId}/assets/${item.tourDetails.id}/${_audioname}`
    console.log("___path___ " + _path)

    if (
      componentAudio.length > 0 &&
      componentAudio[0].imageName === _audioname
    ) {
      if (player != null) {
        //player.getInternalPlayer().src=res.link
        console.log("update player events", player.getInternalPlayer().src)
        player.onProgress = null
        player.onEnded = null
        player.onReady = null
        player.onDuration = null
        player.onEnded = null
        player.onPause = null
        player.onPlay = null
        player.onError = null
      }
      console.log(
        "componentAudio[0].backgroundUrl :>> ",
        componentAudio[0].backgroundUrl
      )
      // setbgAssetFullPath(componentAudio[0].backgroundUrl)
      const fileData = dataURLtoFile(
        componentAudio[0].backgroundUrl,
        componentAudio[0].imageName
      )
      console.log("fileData inside getTempAudioPath :>> ", fileData)
      const srcAudio = URL.createObjectURL(fileData)
      setbgAssetFullPath(srcAudio)
      if (player != null) {
        player.getInternalPlayer().src = componentAudio[0].backgroundUrl
        player.onProgress = handleProgress
        player.onEnded = handleProgress
        player.onReady = handleReady
        player.onDuration = handleDuration
        player.onEnded = gotoNextItem
        player.onPause = () => {
          if (state.playing && !player.getInternalPlayer().ended) {
            setState({ ...state, playing: false })
          }
        }
        player.onPlay = () => {
          if (!state.playing) {
            setState({ ...state, playing: true })
          }
        }
        player.onError = () => {
          setState({ ...state, playing: false })
        }
      }
    } else {
      await AssetDatabase.getAsset(_path)
        .then((res) => {
          if (player != null) {
            //player.getInternalPlayer().src=res.link
            console.log("update player events", player.getInternalPlayer().src)
            player.onProgress = null
            player.onEnded = null
            player.onReady = null
            player.onDuration = null
            player.onEnded = null
            player.onPause = null
            player.onPlay = null
            player.onError = null
          }
          console.log("res: ", res)
          console.log("res.link: ", res.link)

          //accounts for when the audio has format .aac and grabbing duration is incorrect via the ReactPlayer's onDuration method
          // const metadata = await mm.fetchFromUrl(res.link, {
          //   duration: true,
          // })
          // console.log("metadata: ", metadata)
          //setDuration(metadata.format.duration)

          setbgAssetFullPath(res.link)
          if (player != null) {
            player.getInternalPlayer().src = res.link
            player.onProgress = handleProgress
            player.onEnded = handleProgress
            player.onReady = handleReady
            player.onDuration = handleDuration
            player.onEnded = gotoNextItem
            player.onPause = () => {
              if (state.playing && !player.getInternalPlayer().ended) {
                setState({ ...state, playing: false })
              }
            }
            player.onPlay = () => {
              if (!state.playing) {
                setState({ ...state, playing: true })
              }
            }
            player.onError = () => {
              setState({ ...state, playing: false })
            }
          }
        })
        .catch((err) => console.log(err))
    }
  }

  // console.log('width: ',myComponenetWidth);
  const refCallback = (element) => {
    if (element) {
      console.log(element.getBoundingClientRect())
      const info = element.getBoundingClientRect()
      console.log(
        "resize 360: ",
        info.width,
        info.height,
        (info.width / 9) * 16
      )
      setMyComponentWidth(info.width)
      setMyComponentHeight((info.width / 9) * 16)
      //this.props.getSize(element.getBoundingClientRect());
    }
  }
  const [slideShowLoaded, setSlideShowLoaded] = React.useState(false)
  useEffect(() => {
    if (item.data.advancedSettings.images !== undefined) {
      //item.data.advancedSettings.images = [];
      let tempSlideShow = []
      let currentIndex = 0
      console.log("createAudioImage update")
      item.data.advancedSettings.images.forEach(async (slideshow) => {
        let _path = `${item.clientId}/${item.projectId}/assets/${item.tourDetails.id}/${slideshow.name}`
        console.log("___path___ " + _path)
        currentIndex++
        setSlideShowLoaded(true)
      })
    }
  }, [item.data.advancedSettings.images])

  useEffect(() => {
    if (myPlayerRef.current) {
      setPlayer(myPlayerRef.current)
    }
  }, [myPlayerRef])
  const playerHeight = (myComponenetWidth / 9) * 16
  const handleSeekMouseDown = (e) => {
    //this.setState({ seeking: true })
    setState({ ...state, seeking: true })
  }

  const handlePlayPause = () => {
    // console.log('playing--->',state)
    setState({ ...state, playing: !state.playing })
  }

  const handleDuration = (duration) => {
    console.log("onDuration", duration, item.data.advancedSettings.assets.audio)
    //setState({...state, duration:duration })
    if (duration !== null) {
      setDuration(duration)
      // const metadata = await mm.fetchFromUrl(bgAssetFullPath, {
      //   duration: true,
      // })
      // setDuration(metadata.format.duration)
      // console.log("handleReady metaData: ", metadata)
    } else {
      setDuration("isNull")
    }
    if (player != null) {
      player.onProgress = handleProgress
      player.onEnded = handleProgress
      player.onReady = handleReady
      player.onDuration = handleDuration
      player.onEnded = gotoNextItem
      player.onPause = () => {
        if (state.playing && !player.getInternalPlayer().ended) {
          setState({ ...state, playing: false })
        }
      }
      player.onPlay = () => {
        if (!state.playing) {
          setState({ ...state, playing: true })
        }
      }
      player.onError = () => {
        setState({ ...state, playing: false })
      }
    }
    console.log("onDuration2", duration)
  }

  const [volume, setVolume] = React.useState(DefaultSettings.volume)

  const seekTo = (played) => {
    // console.log(
    //   "seekTo",
    //   duration,
    //   played,
    //   player.getInternalPlayer().currentTime
    // )
    console.log(
      "seekTo",
      duration,
      played,
      player.getInternalPlayer().currentTime
    )
    //let playedSeek = duration * played;
    let playedSeek = played
    player.seekTo(playedSeek)
    // player.getInternalPlayer().currentTime = playedSeek
    setState({
      ...state,
      played: played,
      playedSeconds: played,
    })
    // let playedSeek = duration * played
    // try {
    //   player.getInternalPlayer().currentTime = playedSeek
    // } catch (err) {
    //   console.log("error seeking:", err)
    // }

    //player.seekTo(playedSeek,"seconds")
  }
  const handleProgress = (trackInfo) => {
    //console.log("onProgress", trackInfo)
    // We only want to update time slider if we are not currently seeking

    if (player !== null && player.getInternalPlayer() !== null) {
      /*console.log('handleProgress:',trackInfo.playedSeconds, player.getInternalPlayer().duration);
        let duration = player.getInternalPlayer().duration;
        console.log('duration:',duration);
        handleDuration(duration)*/
    }
    if (!state.seeking) {
      setState({ ...state, playedSeconds: trackInfo.playedSeconds })
    }
  }
  const onPrevious = () => {
    // if (previewMode === false) {
    //   window.alert("The previous function will only work in preview mode")
    //   return
    // }
    console.log("previousItem: ", itemContext.previousItem)
    if (player !== null) {
      player.onProgress = null
      setDuration(0)
      setState({ ...state, duration: 0, playedSeconds: 0, seeking: false })
      //console.log('update player events',player.getInternalPlayer().src );
      player.onProgress = null
      player.onEnded = null
      player.onReady = null
      player.onDuration = null
      player.onEnded = null
      player.onPause = null
      player.onPlay = null
      player.onError = null
    }
    updateItem(itemContext.previousItem, "Blocks onblockclick")
    if (player !== null) {
      player.onProgress = null
      setDuration(0)
      setState({ ...state, duration: 0, playedSeconds: 0, seeking: false })
      //console.log('update player events',player.getInternalPlayer().src );
      player.onProgress = null
      player.onEnded = null
      player.onReady = null
      player.onDuration = null
      player.onEnded = null
      player.onPause = null
      player.onPlay = null
      player.onError = null
    }
  }
  const gotoNextItem = () => {
    if (player !== null) {
      //player.getInternalPlayer().src=null;
      player.onProgress = null
      player.onEnded = null
      player.onReady = null
      player.onDuration = null
      player.onEnded = null
      player.onPause = null
      player.onPlay = null
      player.onError = null
    }

    // if (previewMode === false && DefaultSettings.displayMode === "CMS") {
    //   window.alert("The next function will only work in preview mode")
    //   return
    // }
    // if(buttonPressed.return|| item.data.advancedSettings.link === null || item.data.advancedSettings.link === undefined){

    if (buttonPressed !== null) {
      if (buttonPressed.returnLink) {
        console.log("previousItem: ", itemContext.previousItem)
        //player.onProgress = null;
        updateItem(itemContext.previousItem, "Blocks onblockclick")
        setDuration(0)
        setState({ ...state, duration: 0, playedSeconds: 0, seeking: false })
        //player.onProgress = handleProgress;
        return
      }
    }
    if (
      (item.data.advancedSettings.link === null ||
        item.data.advancedSettings.link === undefined) &&
      !item.data.advancedSettings.toKeypad
    ) {
      console.log("previousItem: ", itemContext.previousItem)
      //player.onProgress = null;
      updateItem(itemContext.previousItem, "Blocks onblockclick")
      setDuration(0)
      setState({ ...state, duration: 0, playedSeconds: 0, seeking: false })
      //player.onProgress = handleProgress;
      return
    } else {
      if (item.data.advancedSettings.toKeypad) {
        let keypadItem = DefaultSettings.keypadItem
        keypadItem.clientId = item.clientId
        keypadItem.tourDetails = item.tourDetails
        keypadItem.projectId = item.projectId
        keypadItem.projectDetails = item.projectDetails
        updateItem(keypadItem, "update to keypad")
      } else {
        let linkItem = null

        siblings.forEach((element) => {
          if (element.id === item.data.advancedSettings.link) {
            linkItem = element
          }
        })
        // player.onProgress = null;
        updateItem(linkItem, "Blocks onblockclick")
        setDuration(0)
        setState({ ...state, duration: 0, playedSeconds: 0, seeking: false })
        return
      }
    }
  }

  const showImageSet = () => {
    console.log("showImageSet")
    //state.playing
    setState({ ...state, playing: false })
    setOpenSettings(true)
  }

  middleRows = []
  let bckPauseImage = require("../../../images/pause.png")
  let bckPlayImage = require("../../../images/play.png")
  const slideshowSettings = [
    {
      title: "1",
      time: 0,
    },
    {
      title: "2",
      time: 5,
    },
    {
      title: "3",
      time: 10,
    },
  ]
  const getSlideshowImage = () => {
    let currentSlideShow = null
    let count = 0
    let foundCount = 0
    let nextSlideShow = null
    let currentImage = null
    let slideImages = []
    if (item.data.advancedSettings.images !== undefined) {
      //item.data.advancedSettings.images = [];
      item.data.advancedSettings.images.forEach((slideshow) => {
        if (count === 0 || state.playedSeconds > slideshow.time) {
          currentSlideShow = slideshow
          foundCount = count
          currentImage = (
            <AudioImage
              key={"slide" + item.id + count}
              currentSlideShow={currentSlideShow}
              onClick={() => {
                //console.log("onclick image")
                //setOnClickForPlayer(true)
              }}
              viewStyle={{
                width: TourPlayer.width,
                height: TourPlayer.height,
                position: "absolute",
                left: 0,
                top: 0,
                objectFit: "fill",
              }}
              device={device}
              tourPlayer={{
                width: TourPlayer.width,
                height: TourPlayer.height,
              }}
              //hideLinked={true}
              renderToImage={true}
            />
          )
          slideImages.push(currentImage)
        } else if (DefaultSettings.displayMode !== "CMS") {
          slideImages.push(
            <AudioImage
              key={"slide" + item.id + count}
              currentSlideShow={currentSlideShow}
              onClick={() => {
                //console.log("onclick image")
                //setOnClickForPlayer(true)
              }}
              viewStyle={{
                width: TourPlayer.width,
                height: TourPlayer.height,
                position: "absolute",
                left: 0,
                top: 0,
                objectFit: "fill",
              }}
              device={device}
              tourPlayer={{
                width: TourPlayer.width,
                height: TourPlayer.height,
              }}
              //hideLinked={true}
              renderToImage={true}
            />
          )
        }
        count++
      })
      if (item.data.advancedSettings.images.length > foundCount + 1) {
        nextSlideShow = item.data.advancedSettings.images[foundCount + 1]
      }
    }

    if (currentSlideShow != null) {
      //console.log('currentSlideShow',currentSlideShow);
      return (
        <React.Fragment>
          {slideImages}
          <Grid
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              objectFit: "fill",
              width: TourPlayer.width,
              height: TourPlayer.height,
              backgroundColor: DefaultSettings.webAppBackground,
            }}
          ></Grid>

          {currentImage}
        </React.Fragment>
      )
    } else {
      return null
    }
  }
  middleRows = (
    <div
      style={{
        postion: "absolute",
        backgroundColor: DefaultSettings.webAppBackground,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "block",
        outline: "none",
        width: TourPlayer.width,
        height: TourPlayer.height,
      }}
    >
      {slideShowLoaded ? getSlideshowImage() : <p>loading</p>}
    </div>
  )

  //middleRows = (<div style={{postion:'absolute',display:'block',outline:'none',flexGrow:1, flex:1,width:'100%', height:myComponenetHeight,backgroundColor:'#fbd'}}> </div>)
  const interactiveLayer = (
    <div
      ref={myRef}
      style={{
        position: "absolute",
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        width: TourPlayer.width,
        height: TourPlayer.height,
      }}
    >
      <Grid
        style={{ position: "relative", left: 0, top: 0, right: 0, bottom: 0 }}
      >
        {middleRows}
      </Grid>
      {blockLinkTo}
    </div>
  )
  let playerControlsKey = "controls"
  if (player !== null) {
    //playerControlsKey = player.getInternalPlayer().src+item.id+'controls';
  }
  const playerControls = (
    <PlayerController
      duration={duration}
      playedSeconds={state.playedSeconds}
      playing={state.playing}
      onClickForPlayer={onClickForPlayer}
      setOnClickForPlayer={setOnClickForPlayer}
      setVolume={setVolume}
      volume={DefaultSettings.volume}
      seekTo={seekTo}
      //onClick =
      handlePlayPause={handlePlayPause}
      toNextItem={gotoNextItem}
      toPreviousItem={onPrevious}
    />
  )
  // console.log('playing--->',state.playing, state.playedSeconds, state.duration);

  const handleReady = (player) => {
    console.log(
      "handleReady is triggered here in AudioImageComponent :>> ",
      player,
      player.getInternalPlayer()
    )
    // musicMetadata.parseFile(bgAssetFullPath).then((metadata) => {
    //   // metadata has all the metadata found in the blob or file
    //   console.log("handleReady metaData: ", metadata)
    // })

    //this.player = player            // Store a player that is ready for methods
    //this.player.getInternalPlayer() // Internal player now ready
    //player
    //seekable.length
    //console.log('getInternalPlayer',player.getInternalPlayer().seekable.end(player.getInternalPlayer().seekable.length - 1));
    //console.log('getInternalPlayer2',player.getInternalPlayer().seekable.length);
    //console.log('getInternalPlayer2',player.getInternalPlayer().duration);
    /*if(player.getInternalPlayer().seekable.length === 0 && player.getInternalPlayer().duration===Infinity){
          console.log('getInternalPlayer2',player.getInternalPlayer().duration);
          
          player.getInternalPlayer().addEventListener("timeupdate",()=>{

            //console.log(player.getCurrentTime())
            if (!state.seeking) {
              setState({...state, playedSeconds:player.getCurrentTime()})
            }
            
          })
        }*/

    setPlayer(player)
  }
  let backgroundLayer = (
    <div
      style={{
        postion: "absolute",
        width: TourPlayer.width,
        height: TourPlayer.height,
        backgroundColor: "#ff0",
      }}
    >
      <ReactPlayer
        onReady={handleReady}
        url={bgAssetFullPath}
        onDuration={handleDuration}
        onEnded={gotoNextItem}
        onPause={() => {
          if (state.playing && !player.getInternalPlayer().ended) {
            setState({ ...state, playing: false })
          }
        }}
        onPlay={() => {
          if (!state.playing) {
            setState({ ...state, playing: true })
          }
        }}
        onError={() => {
          setState({ ...state, playing: false })
        }}
        onProgress={handleProgress}
        playing={state.playing}
        playsinline={true}
        volume={DefaultSettings.volume}
        width={myComponenetWidth}
        height={myComponenetHeight}
        style={{ postion: "relative" }}
        config={{
          file: {
            forceAudio: true,
          },
        }}
      />
    </div>
  )

  /*if(player!=null){
  //player.getInternalPlayer().src=res.link
  console.log('update player events',player.getInternalPlayer().src );
  player.onProgress = handleProgress;
  player.onEnded = gotoNextItem;
  player.onReady=handleReady
  player.onDuration=handleDuration
  player.onEnded=gotoNextItem
  player.onPause=()=>{
    if(state.playing && !player.getInternalPlayer().ended){
      setState({...state, playing: false })
      
    }
  }
  player.onPlay=()=>{
    if(!state.playing){
      setState({...state, playing: true })
    }
  }
  player.onError=()=>{
    setState({...state, playing: false })
  }
}*/

  ///return the three layers
  return (
    <Grid
      style={{
        width: TourPlayer.width,
        height: TourPlayer.height,
        transformOrigin: "top left",
        transform: `rotate(${portrait ? 0 : -90}deg) translate(${
          portrait ? 0 : -100
        }%)`,
      }}
      onClick={() => {
        //console.log("onclick image")
        setOnClickForPlayer(true)
      }}
    >
      {playerControls}

      {interactiveLayer}
      {backgroundLayer}
    </Grid>
  )
}
export const AudioImagePlayerOptions = (props) => {
  const itemContext = useContext(ItemContext)
  const { item, previewMode, siblings, updateItem, handleAssetsViewerOpen } =
    itemContext
  const mainProjectPath = `${item.clientId}/${item.projectId}`
  const [openAssetBrower, setOpenAssetBrower] = React.useState(false)
  const assetRequirements = {
    presentMatches: false,
    data: [
      {
        type: "mp3",
      },
      {
        type: "aac",
      },
    ],
  }
  const [openSettings, setOpenSettings] = React.useState(false)
  const selectionTool = (
    <React.Fragment>
      {/* <Button
        variant="contained"
        color="primary"
        style={styles.button}
        onClick={(e) => {
          handleAssetsViewerOpen(
            assetRequirements,
            item.data.advancedSettings.assets.audio,
            (src, imgName) => {
              console.log("setting -> src --> ", src)
              console.log("fileSelected:  ", imgName, src)
              let imagePath = src
              item.data.advancedSettings.assets.audio = {
                name: imgName,
              }
              //getTempImagePath(imgName)
              updateItem(item, previewMode)
            },
            previewMode
          )
        }}
      >
        Select Audio
      </Button>
      <Button
        variant="contained"
        color="primary"
        style={styles.button}
        onClick={(e) => {
          setOpenSettings(true)
        }}
      >
        Select Images
      </Button>
      <AudioImageItemSettings
        open={openSettings}
        onClose={() => {
          setOpenSettings(false)
        }}
      /> */}
    </React.Fragment>
  )

  ///return the three layers
  return selectionTool
}
export const AudioImageAdvancedSettingsForm = (props) => {
  const itemContext = useContext(ItemContext)
  const {
    item,
    previewMode,
    siblings,
    updateItem,
    openingComponentSelector,
    handleAssetsViewerOpen,
    TourPlayer,
  } = itemContext
  const { advancedSettings } = item.data
  const [openSettings, setOpenSettings] = React.useState(false)

  const [selectedValue, setSelectedValue] = React.useState(
    item.projectDetails?.data?.themeSettings ?? "dark"
  )
  const [selectedFontValue, setSelectedFontValue] = React.useState(
    item.projectDetails?.data?.fontSettings?.hex ?? "#ffffff"
  )

  const trancriptColorTimerRef = React.useRef(null)

  const handleChange = async (event) => {
    // event.persist();

    const value = event.target.value
    advancedSettings.themeSettings = value
    setSelectedValue(event.target.value)

    let compDetails = {
      clientId: item.projectDetails.data.clientId,
      projectId: item.projectDetails.id,
      data: {
        themeSettings: value,
      },
    }
    var newProjectDetails = await Database.updateProject(compDetails)
    // const updateTourDetails = await Database.updateTour(
    //   {
    //     clientId: item.projectDetails.data.clientId,
    //     projectId: item.projectDetails.id,
    //   },
    //   item.tourDetails.id,
    //   {
    //     themeSettings: value
    //   }
    // )
    updateItem(item, "theme settings changes")
  }

  const handleFontChange = async (event) => {
    // event.persist();

    const value = event
    advancedSettings.fontSettings = value
    let compDetails = {
      clientId: item.projectDetails.data.clientId,
      projectId: item.projectDetails.id,
      data: {
        fontSettings: value,
      },
    }
    await Database.updateProject(compDetails)

    updateItem(item, "font settings changes")
    // await Database.updateTour(
    //   {
    //     clientId: item.projectDetails.data.clientId,
    //     projectId: item.projectDetails.id,
    //   },
    //   item.tourDetails.id,
    //   {
    //     fontSettings: value
    //   }
    // )
  }

  const changeSize = (size) => {
    console.log(size)
    advancedSettings.size = size

    updateItem(item, "audio image component")
  }

  const handleBarChange = (name) => (event) => {
    console.log("change: " + name, event.target.checked)
    advancedSettings.barMode = name
    updateItem(item, "audio image component")
  }

  const listItemArray = []
  for (let index = 0; index < 25; index++) {
    if (index >= advancedSettings.size) {
      listItemArray.push(index)
    }
  }

  let rowItems = []

  if (item.data.advancedSettings.images !== undefined) {
    let count = 0
    item.data.advancedSettings.images.forEach((element, elementIndex) => {
      rowItems.push(
        <TableRow key={elementIndex}>
          <TableCell>{elementIndex + 1}</TableCell>
          <TableCell>{element.time}</TableCell>
          <TableCell>
            <AudioImage
              currentSlideShow={element}
              viewStyle={{
                maxHeight: 150,
                objectFit: "cover",
                textAlign: "center",
                // marginTop: 5,
                // marginLeft: 9,
              }}
            />
          </TableCell>
        </TableRow>
      )
      count++
    })
  }
  const assetRequirements = {
    presentMatches: false,
    data: [
      {
        type: "mp3",
      },
      {
        type: "aac",
      },
    ],
  }
  const onTranscriptChange = (event) => {
    console.log("change: " + event.target.checked, advancedSettings.transcript)
    advancedSettings.transcript = !advancedSettings.transcript
    updateItem(item, previewMode)
  }
  return (
    <Grid>
      <Grid container>
        <AutoAssignButton
          onSelection={(val) => {
            console.log("val:", val)
            let tempCode
            if (val === "keypad") {
              tempCode = ("000" + item.data.code).slice(-4)
            } else {
              tempCode = item.data.reference
            }
            if (val === "reference" || val === "keypad") {
              const assetPresetRequirements = {
                presentMatches: true,
                data: [
                  {
                    type: "mp3_aac",
                    title: "Audio",
                    code: tempCode,
                  },
                ],
              }
              // assetPresetRequirements.data.push({
              //   type: "jpg",
              //   title: "Slideshow image " + 1,
              //   index: 0,
              //   code: tempCode,
              // })
              for (let index = 0; index < 100; index++) {
                //const element = array[index];
                assetPresetRequirements.data.push({
                  type: "jpg",
                  title: "Slideshow image " + (index + 1),
                  index: index,
                  code: tempCode + "_" + ("00" + (index + 1)).slice(-2),
                })
              }
              console.log("assetPresetRequirements", assetPresetRequirements)
              handleAssetsViewerOpen(
                assetPresetRequirements,
                item.data.advancedSettings.assets.main,
                (meta) => {
                  console.log("asset selected", meta)
                  // background

                  //item.data.advancedSettings.assets.audio
                  let audio = assetPresetRequirements.data.find(
                    (obj) => obj.title === "Audio"
                  )
                  let duration = null
                  if (audio?.match) {
                    console.log("asset selected progress audio", audio.match)
                    const { dropboxInfo } = audio.match
                    duration = audio.match.fileInfo.duration
                    item.data.advancedSettings.assets.audio = {
                      meta: { path_lower: dropboxInfo.path_lower },
                      name: dropboxInfo.name,
                    }
                  }
                  let images = []
                  let totalSlides = 0
                  for (let index = 0; index < 100; index++) {
                    let bck = assetPresetRequirements.data.find(
                      (obj) => obj.title === "Slideshow image " + (index + 1)
                    )
                    if (bck?.match) {
                      totalSlides = index
                    }
                  }
                  for (let index = 0; index <= totalSlides; index++) {
                    let bck = assetPresetRequirements.data.find(
                      (obj) => obj.title === "Slideshow image " + (index + 1)
                    )

                    if (bck?.match) {
                      const { dropboxInfo } = bck.match
                      if (index === 0) {
                        item.data.advancedSettings.assets.main = {
                          meta: { path_lower: dropboxInfo.path_lower },
                          name: dropboxInfo.name,
                        }
                        if (bck.match.fileInfo.width !== undefined) {
                          if (
                            bck.match.fileInfo.width > bck.match.fileInfo.height
                          ) {
                            item.data.orientation = "Landscape"
                          } else {
                            item.data.orientation = "Portrait"
                          }
                        }
                      }
                      images.push({
                        meta: { path_lower: dropboxInfo.path_lower },
                        name: dropboxInfo.name,
                        time:
                          duration !== null && duration !== undefined
                            ? Math.floor((duration / (totalSlides + 1)) * index)
                            : index,
                      })
                      console.log(
                        "asset selected create new Slideshow image",
                        bck.match
                      )
                    } else {
                      images.push({
                        meta: "",
                        name: "",
                        time:
                          duration !== null && duration !== undefined
                            ? Math.floor((duration / (totalSlides + 1)) * index)
                            : index,
                      })
                    }
                  }
                  item.data.advancedSettings.images = images
                  updateItem(item, "audio image component")
                },
                previewMode
              )
            }
          }}
        />

        <ComponentLink
          linkItem={item.data.advancedSettings}
          mainItem={item}
          title={"Next"}
        />
      </Grid>
      <Grid item style={{ width: "40%", marginTop: 20 }}>
        <SelectAsset
          title={"Audio"}
          assetRequirements={assetRequirements}
          asset={item.data.advancedSettings.assets.audio}
          onSelect={(meta, imgName) => {
            console.log("setting -> src --> ", meta)
            console.log("setting -> name --> ", imgName)
            item.data.advancedSettings.assets.audio = {
              name: imgName,
            }
            //getTempImagePath(imgName)
            updateItem(item, "audio image component")
          }}
        />
      </Grid>
      <Card
        style={{
          width: "100%",
          border: "1px solid #dedede",
          boxShadow: "none",
          borderRadius: 0,
          margin: "20px 0px",
        }}
      >
        <Grid
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
            padding: 5,
          }}
        >
          <Typography variant="h4" component="h2" style={{ marginLeft: 15 }}>
            Image Slideshow
          </Typography>
          <IconButton
            aria-label="Edit Slideshow"
            color="secondary"
            onClick={(e) => {
              setOpenSettings(true)
            }}
          >
            <EditIcon />
          </IconButton>
        </Grid>

        <AudioImageItemSettings
          open={openSettings}
          onClose={() => {
            setOpenSettings(false)
          }}
        />
        {/* <Divider /> */}
        <div
          style={{
            alignItems: "center",
            flexFlow: "wrap",
            justifyContent: "start",
            padding: 15,
            backgroundColor: "#f9f9f9",
          }}
        >
          {item.data.advancedSettings?.images.map((element, elementIndex) => {
            return (
              <Grid item style={{ display: "inline-block" }}>
                <Typography style={{ textAlign: "center" }}>
                  {elementIndex + 1}
                </Typography>
                <Card
                  alignItems="center"
                  justify="center"
                  style={{
                    //backgroundColor: "#5B5B5B",
                    maxWidth: 84,
                    maxHeight: 250,
                    margin: 10,
                    border: "1px solid #dedede",
                  }}
                  className={"slideshow-images"}
                  key={element.id} //this will be different for each image, so when updated will cause a rerender
                >
                  <CardMedia
                    //className={classes.media}
                    style={
                      {
                        // minWidth: 113, //2 for borders
                      }
                    }
                    title="Contemplative Reptile"
                  >
                    <AudioImage
                      currentSlideShow={element}
                      viewStyle={{
                        height: TourPlayer.height * 0.25,
                        // height: 150,
                        transform: "scale(0.25)",
                        transformOrigin: "top left",

                        // width: "100%",
                        // maxHeight: 150,
                        // objectFit: "cover",
                        // marginTop: 5,
                        // marginLeft: 9,
                      }}
                      // containerWidth={113}
                      // containerHeight={150}
                    />
                  </CardMedia>
                  <CardContent style={{ padding: 10, textAlign: "center" }}>
                    {format(element.time)}
                  </CardContent>
                </Card>
              </Grid>
            )
          })}
        </div>
      </Card>
      <Card
        style={{
          width: "100%",
          border: "1px solid #dedede",
          boxShadow: "none",
          borderRadius: 0,
          margin: "20px 0px",
        }}
      >
        <Grid
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "",
            flexDirection: "column",
            padding: 5,
            alignItems: "flex-start",
          }}
        >
          <Typography variant="h4" component="h2" style={{ marginLeft: 15 }}>
            Theme and Font Settings
          </Typography>
          <Grid>
            <div
              style={{
                width: "100%",
                boxShadow: "none",
                flexDirection: "row",
                borderRadius: 0,
                margin: "20px 0px",
              }}
            >
              <Typography
                variant="h4"
                component="h3"
                style={{ marginLeft: 15 }}
              >
                Theme Settings
              </Typography>
              <div style={{ marginLeft: 15 }}>
                <FormControlLabel
                  checked={selectedValue === "dark"}
                  onChange={handleChange}
                  value="dark"
                  control={<Radio />}
                  label="Dark"
                />
                <FormControlLabel
                  checked={selectedValue === "light"}
                  onChange={handleChange}
                  value="light"
                  control={<Radio />}
                  label="Light"
                />
              </div>
            </div>
          </Grid>
          <Grid style={{ width: "100%" }}>
            <div
              style={{
                width: "100%",
                boxShadow: "none",
                flexDirection: "row",
                borderRadius: 0,
                margin: "20px 0px",
              }}
            >
              <Typography
                variant="h4"
                component="h3"
                style={{ marginLeft: 15 }}
              >
                Font Settings
              </Typography>
              <div style={{ marginLeft: 7 }}>
                <CustomColorPicker
                  defaultColor={selectedFontValue}
                  enableRGBColor={true}
                  onChange={(color) => {
                    console.log("color :>> ", color)
                    setSelectedFontValue(color)
                    handleFontChange(color)
                  }}
                  width={50}
                  height={50}
                />
                <p style={{ marginLeft: "8px" }}>
                  {selectedFontValue?.hex
                    ? selectedFontValue?.hex
                    : selectedFontValue}
                </p>
              </div>

              {/* <div style={{ marginLeft: 15, display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)' }}>
                {
                  FontSettings.map(item => {
                    return (
                      <FormControlLabel checked={selectedFontValue === item.value} onChange={handleFontChange} value={item.value} control={<Radio />} label={item.name} />
                    )
                  })
                }
               <FormControlLabel checked={selectedFontValue === 'white'} onChange={handleFontChange} value="white" control={<Radio />} label="White" />
                <FormControlLabel checked={selectedFontValue === 'snow'} onChange={handleFontChange} value="snow" control={<Radio />} label="Snow" />
                <FormControlLabel checked={selectedFontValue === 'honeydew'} onChange={handleFontChange} value="honeydew" control={<Radio />} label="Honeydew" />
                <FormControlLabel checked={selectedFontValue === 'mintcream'} onChange={handleFontChange} value="mintcream" control={<Radio />} label="Mint Cream" />
                <FormControlLabel checked={selectedFontValue === 'azure'} onChange={handleFontChange} value="azure" control={<Radio />} label="Azure" />
                <FormControlLabel checked={selectedFontValue === 'aliceblue'} onChange={handleFontChange} value="aliceblue" control={<Radio />} label="Alice Blue" />
                <FormControlLabel checked={selectedFontValue === 'ghostwhite'} onChange={handleFontChange} value="ghostwhite" control={<Radio />} label="Ghost White" />
                <FormControlLabel checked={selectedFontValue === 'whitesmoke'} onChange={handleFontChange} value="whitesmoke" control={<Radio />} label="White Smoke" />
                <FormControlLabel checked={selectedFontValue === 'seashell'} onChange={handleFontChange} value="seashell" control={<Radio />} label="Sea Shell" />
                <FormControlLabel checked={selectedFontValue === 'beige'} onChange={handleFontChange} value="beige" control={<Radio />} label="Beige" />
                <FormControlLabel checked={selectedFontValue === 'oldlace'} onChange={handleFontChange} value="oldlace" control={<Radio />} label="Old Lace" />
                <FormControlLabel checked={selectedFontValue === 'floralwhite'} onChange={handleFontChange} value="floralwhite" control={<Radio />} label="Floral White" />
                <FormControlLabel checked={selectedFontValue === 'ivory'} onChange={handleFontChange} value="ivory" control={<Radio />} label="Ivory" />
                <FormControlLabel checked={selectedFontValue === 'antiquewhite'} onChange={handleFontChange} value="antiquewhite" control={<Radio />} label="Antique White" />
                <FormControlLabel checked={selectedFontValue === 'linen'} onChange={handleFontChange} value="linen" control={<Radio />} label="Linen" />
                <FormControlLabel checked={selectedFontValue === 'lavenderblush'} onChange={handleFontChange} value="lavenderblush" control={<Radio />} label="Lavender Blush" />
                <FormControlLabel checked={selectedFontValue === 'mistyrose'} onChange={handleFontChange} value="mistyrose" control={<Radio />} label="Misty Rose" />
                <FormControlLabel checked={selectedFontValue === 'navajowhite'} onChange={handleFontChange} value="navajowhite" control={<Radio />} label="Navajo White" />
              </div> */}
            </div>
          </Grid>
        </Grid>
      </Card>

      <Card>
        <Grid
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
            padding: 5,
          }}
        >
          <Typography variant="h4" component="h2" style={{ marginLeft: 15 }}>
            Audio transcript
          </Typography>
          <FormControlLabel
            control={
              <Checkbox
                checked={advancedSettings.transcript}
                onChange={onTranscriptChange}
                value="transcript"
                color="primary"
              />
            }
            label="Transcript enabled"
          />
        </Grid>

        {advancedSettings.transcript ? (
          <Grid style={{ paddingLeft: "12px" }}>
            <Typography variant="h4" component="h3" style={{ marginLeft: 7 }}>
              Backgound Settings
            </Typography>
            <CustomColorPicker
              defaultColor="#000000"
              enableRGBColor={false}
              onChange={(color) => {
                console.log("color :>> ", color)
                if (trancriptColorTimerRef.current) {
                  clearTimeout(trancriptColorTimerRef.current)
                }
                trancriptColorTimerRef.current = setTimeout(() => {
                  advancedSettings.transcriptBgColor = color
                  updateItem(item, previewMode)
                }, 500)
              }}
              width={50}
              height={50}
            />
          </Grid>
        ) : null}

        <Grid>
          {advancedSettings.transcript ? (
            <TextField
              variant="outlined"
              label="Description"
              style={{ width: "90%", height: "80%", margin: "5%" }}
              multiline={true}
              rows={6}
              value={advancedSettings.transcriptText}
              onChange={(event) => {
                advancedSettings.transcriptText = event.target.value
                updateItem(item, previewMode)
              }}
            />
          ) : null}
        </Grid>
      </Card>
    </Grid>
  )
}
// export const AudioImageBuild = () => { }

export const AudioImageBuild = async (component, buildId) => {}
function format(seconds) {
  const date = new Date(seconds * 1000)
  const hh = date.getUTCHours()
  const mm = date.getUTCMinutes()
  const ss = pad(date.getUTCSeconds())
  if (hh) {
    return `${hh}:${pad(mm)}:${ss}`
  }
  return `${mm}:${ss}`
}

function pad(string) {
  return ("0" + string).slice(-2)
}
